<ng-container thr-parent-form>
    <h3 class="mat-subheading-1 text-blue font-weight-bold">
        {{ 'full-data.indicates-entities-exercise-control'|translate }}
    </h3>

    <table class="table participants mb-4" *ngIf="manager.companies.length > 0">
        <thead>
            <tr>
                <th>{{ 'form.name-entity'|translate }}</th>
                <th width="90px"></th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-company [ngForOf]="manager.companies">
                <tr>
                    <td>
                        <strong>{{ company.name }}</strong>
                    </td>
                    <td class="text-right">
                        <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(company)" *ngIf="!isDisabled">
                            <i class="icon-edit"></i>
                        </button>
                        <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(company)" *ngIf="!isDisabled">
                            <i class="icon-delete"></i>
                        </button>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </table>

    <ng-container *ngIf="adding || editing">
        <mat-form-field class="full-width mb-3 mb-sm-4">
            <input [name]="prefix + 'Name'" matInput [placeholder]="'form.name-entity'|translate" [disabled]="isDisabled" [(ngModel)]="currentCompany.name" #nameCtrl="ngModel">
            <mat-error *ngIf="nameCtrl.hasError('required')">
                {{ 'form.validation.required'|translate }}
            </mat-error>
        </mat-form-field>
    </ng-container>

    <div class="row justify-content-between mb-5" *ngIf="!isDisabled">
        <ng-container *ngIf="!adding && !editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onAdd()">
                    {{ 'general.add-other'|translate }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="adding || editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()" *ngIf="manager.companies.length > 0">
                    {{ 'general.cancel'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4" [ngClass]="{'mt-3 mt-sm-0': manager.companies.length > 0}">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!currentCompany || !currentCompany.name" (click)="onSave()">
                    {{ 'general.add'|translate }}
                </button>
            </div>
        </ng-container>
    </div>
</ng-container>